import { RootState } from "../reducers";

export const getCustomTowToDestinationList = (state: RootState) =>
  state.generalInfo.towToCustomDestinationList;
export const getDuplicateRescue = (state: RootState) => state.generalInfo.duplicateRescue;
export const getPpuFuelPrice = (state: RootState) => state.generalInfo.ppuFuelPrice;
export const getPrimaryLookup = (state: RootState) => state.generalInfo.isPrimaryLookup;
